export const CONTRACT_STATUSES = {
  paper: "Non dématérialisé",
  unsigned: "Dématérialisé non signé",
  signed: "Signé",
  nonLieu: "Non-lieu",
  unknown: "Non renseigné",
};

// Only explicit document states are used; mission dates do not imply signature.
export function getContractStatus(contract) {
  if (String(contract?.EstNonLieu ?? "").trim().toUpperCase() === "O") {
    return CONTRACT_STATUSES.nonLieu;
  }
  const value = contract.signatureStatus ?? contract.dematerializationStatus;
  const normalized = typeof value === "string" ? value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() : "";
  const labels = {
    "non dematerialise": "paper",
    "dematerialise non signe": "unsigned",
    "signe": "signed",
  };
  return CONTRACT_STATUSES[labels[normalized]] || CONTRACT_STATUSES.unknown;
}
